(function () {
  function clean(s) {
    return (s || "")
      .replace(/\u00A0/g, " ")
      .replace(/\r/g, "")
      .trim();
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function parseLinesToRows(lines) {
    const rows = [];
    let key = null;
    let val = [];

    function push() {
      if (!key) return;
      const v = val.join("\n").trim();
      if (v) rows.push([key, v]);
      key = null;
      val = [];
    }

    for (const raw of lines) {
      const line = clean(raw);
      if (!line) continue;

      const m = line.match(/^([^:]{1,80}):\s*(.*)$/);
      if (m) {
        push();
        key = clean(m[1]);
        const first = clean(m[2]);
        if (first) val.push(first);
        continue;
      }

      if (key) val.push(line);
    }

    push();
    return rows;
  }

  function buildTable(rows) {
    let html = '<div class="curio-table">';
    for (const [k, v] of rows) {
      html +=
        '<div class="curio-row">' +
        '<div class="curio-k">' +
        escapeHtml(k) +
        "</div>" +
        '<div class="curio-v">' +
        escapeHtml(v).replaceAll("\n", "<br>") +
        "</div>" +
        "</div>";
    }
    html += "</div>";
    return html;
  }

  function renderParagraphs(container, text) {
    const parts = text
      .split(/\n{2,}/)
      .map((p) => p.trim())
      .filter(Boolean);

    if (!parts.length) {
      container.innerHTML = "";
      return;
    }

    container.innerHTML = parts
      .map((p) => "<p>" + escapeHtml(p).replaceAll("\n", "<br>") + "</p>")
      .join("");
  }

  function ensureMetaUI(descEl) {
    // If your Liquid already created these, use them.
    let wrap = document.querySelector("[data-curio-meta-wrap]");
    let table = document.querySelector("[data-curio-meta-table]");

    // If not, create them right under the description.
    if (!wrap || !table) {
      wrap = document.createElement("div");
      wrap.className = "curio-meta-wrap";
      wrap.setAttribute("data-curio-meta-wrap", "");
      wrap.hidden = true;

      const title = document.createElement("h3");
      title.className = "curio-meta-title";
      title.textContent = "Details";

      table = document.createElement("div");
      table.className = "curio-meta-table";
      table.setAttribute("data-curio-meta-table", "");

      wrap.appendChild(title);
      wrap.appendChild(table);

      // Put the table container right after the description block
      descEl.parentNode.insertBefore(wrap, descEl.nextSibling);
    }

    return { wrap, table };
  }

  function splitAtMetadata(text) {
    const lines = text
      .replace(/\r/g, "")
      .split("\n")
      .map((l) => l.trim());

    let idx = -1;
    for (let i = 0; i < lines.length; i++) {
      const t = lines[i].toLowerCase();
      if (t === "metadata" || t === "metadata:" || t.startsWith("metadata:")) {
        idx = i;
        break;
      }
    }

    if (idx === -1) return null;

    const before = lines.slice(0, idx).join("\n").trim();
    const after = lines.slice(idx + 1).filter(Boolean);
    return { before, after };
  }

  // NEW: WARNING block detection and styling (does not touch other logic)
  function ensureWarningStyles() {
    if (document.getElementById("curio-warning-style")) return;

    const style = document.createElement("style");
    style.id = "curio-warning-style";
    style.textContent =
      ".curio-warning{border:1px solid rgba(220,38,38,.25);background:rgba(220,38,38,.06);border-radius:12px;padding:12px 12px;margin:0 0 12px 0}" +
      ".curio-warning__title{font-weight:900;letter-spacing:.04em;text-transform:uppercase;color:#b91c1c;font-size:13px;line-height:1.2;margin:0 0 6px 0}" +
      ".curio-warning__body{color:#b91c1c;font-weight:700;font-size:12px;line-height:1.35;margin:0}" +
      ".curio-warning__body br{line-height:1.5}";
    document.head.appendChild(style);
  }

  function extractWarningBlock(text) {
    // Looks only at the top of the description
    // Expected first line formats:
    // "WARNING - PREORDER"
    // "WARNING: PREORDER"
    // "WARNING PREORDER" (less strict)
    const raw = (text || "").replace(/\r/g, "").trimStart();
    if (!raw) return null;

    const lines = raw.split("\n");

    // Find first non-empty line
    let firstIdx = -1;
    for (let i = 0; i < lines.length; i++) {
      if (clean(lines[i])) {
        firstIdx = i;
        break;
      }
    }
    if (firstIdx === -1) return null;

    const firstLine = clean(lines[firstIdx]);

    // Match WARNING header
    const m =
      firstLine.match(/^warning\s*[-:–—]\s*(.+)$/i) ||
      firstLine.match(/^warning\s+(.+)$/i);

    if (!m) return null;

    const title = clean(m[1] || "");
    if (!title) return null;

    // Body continues until first blank line after the header
    const bodyLines = [];
    let i = firstIdx + 1;
    for (; i < lines.length; i++) {
      const l = lines[i];
      if (!clean(l)) break;
      bodyLines.push(l);
    }

    const body = clean(bodyLines.join("\n"));
    const rest = clean(lines.slice(i + 1).join("\n")); // skip the blank line

    return { title, body, rest };
  }

  function buildWarningHtml(title, body) {
    ensureWarningStyles();

    const safeTitle = escapeHtml(title);
    const safeBody = escapeHtml(body).replaceAll("\n", "<br>");

    // Title uses the PREORDER part, body stays red and readable
    let html = '<div class="curio-warning" role="note" aria-label="Warning">';
    html += '<div class="curio-warning__title">' + safeTitle + "</div>";
    if (body) {
      html += '<div class="curio-warning__body">' + safeBody + "</div>";
    }
    html += "</div>";
    return html;
  }

  function processOne(descEl) {
    if (!descEl) return;
    if (descEl.dataset.curioMetaProcessed === "1") return;

    const text = clean(descEl.innerText || descEl.textContent || "");
    if (!text) return;

    const split = splitAtMetadata(text);
    if (!split) return;

    const { wrap, table } = ensureMetaUI(descEl);

    const rows = parseLinesToRows(split.after);
    if (!rows.length) return;

    // NEW: extract optional WARNING block from the top of the non-metadata text
    const warning = extractWarningBlock(split.before);

    if (warning) {
      // Render WARNING + remaining description paragraphs
      const warningHtml = buildWarningHtml(warning.title, warning.body);

      // Build the rest as paragraphs (same behavior as before)
      const tmp = document.createElement("div");
      renderParagraphs(tmp, warning.rest);

      descEl.innerHTML = warningHtml + tmp.innerHTML;
    } else {
      // Original behavior
      renderParagraphs(descEl, split.before);
    }

    // Render metadata table (unchanged)
    table.innerHTML = buildTable(rows);
    wrap.hidden = false;

    descEl.dataset.curioMetaProcessed = "1";
  }

  function run() {
    // Prefer your dedicated container if present, otherwise fall back to any product description.
    const candidates = [];
    document.querySelectorAll("[data-curio-desc-visible]").forEach((el) => candidates.push(el));
    if (!candidates.length) {
      document.querySelectorAll(".product__description.rte").forEach((el) => candidates.push(el));
    }

    candidates.forEach(processOne);
  }

  // Run now
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Re-run on Shopify section updates / dynamic DOM changes
  const obs = new MutationObserver(function () {
    run();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  "use strict";

  var TYPE_NEW = "curiosity_trade_teaser_height";
  var TYPE_OLD = "trade-teaser-height"; // compatibility
  var TYPE_GET = "curiosity_trade_teaser_get_height";

  function clamp(n, min, max) {
    n = Number(n);
    if (!Number.isFinite(n)) return null;
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  function getIframes() {
    return Array.prototype.slice.call(
      document.querySelectorAll('iframe[data-trade-teaser="1"]')
    );
  }

  function applyHeight(iframe, height) {
    iframe.style.minHeight = "0px";
    iframe.style.maxHeight = "none";
    iframe.style.overflow = "hidden";
    iframe.style.display = "block";
    iframe.style.height = height + "px";
  }

  function requestHeight(iframe) {
    try {
      var key = String(iframe.getAttribute("data-key") || "");
      if (!key || !iframe.contentWindow) return;
      iframe.contentWindow.postMessage({ type: TYPE_GET, key: key }, "*");
    } catch (e) {}
  }

  // Store last known height per key
  var lastByKey = Object.create(null);

  window.addEventListener("message", function (event) {
    var data = event && event.data ? event.data : null;
    if (!data || typeof data !== "object") return;

    var t = data.type;
    if (t !== TYPE_NEW && t !== TYPE_OLD) return;

    var key = String(data.key || "");
    var height = clamp(data.height, 44, 900);
    if (!key || height === null) return;

    lastByKey[key] = height;

    var iframes = getIframes();
    for (var i = 0; i < iframes.length; i++) {
      var iframe = iframes[i];
      if (String(iframe.getAttribute("data-key") || "") !== key) continue;
      applyHeight(iframe, height);
    }
  });

  function init() {
    var iframes = getIframes();
    if (!iframes.length) return;

    for (var i = 0; i < iframes.length; i++) {
      var iframe = iframes[i];

      // baseline collapsed size
      iframe.style.minHeight = "0px";
      if (!iframe.style.height) iframe.style.height = "56px";

      // ask for height repeatedly to ensure we catch collapse
      requestHeight(iframe);

      (function (f) {
        setTimeout(function () { requestHeight(f); }, 150);
        setTimeout(function () { requestHeight(f); }, 400);
        setTimeout(function () { requestHeight(f); }, 900);
      })(iframe);
    }
  }

  // Self-heal: every 2s, re-apply last known height and request again
  setInterval(function () {
    var iframes = getIframes();
    for (var i = 0; i < iframes.length; i++) {
      var iframe = iframes[i];
      var key = String(iframe.getAttribute("data-key") || "");
      if (!key) continue;

      if (lastByKey[key]) {
        applyHeight(iframe, lastByKey[key]); // includes shrinking
      }
      requestHeight(iframe);
    }
  }, 2000);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Dawn editor events
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);
})();